export const textFilter = (features, field, value) => {
    const filtered = [];

    if (!value.length) {
        return features;
    }
    const _value = value.toLowerCase();

    features.forEach((feature) => {
        if (feature.get('obj').get(field)) {
            const objectValue = feature.get('obj').get(field).toLowerCase();
            if (objectValue.indexOf(_value) !== -1) {
                filtered.push(feature);
            }
        }
    });

    return filtered;
};

export const listObjectsFilter = function(features, field, value, config) {
    const filtered = [];

    if (value.length === 0) {
        return features;
    }
    let _value = value.map(it => (typeof it === 'string' ? it.replace('&#x27;', "'").toLowerCase() : it));
    features.forEach((feature) => {
        if (feature.get('obj').get(field)) {
            let objectValue = feature.get('obj').get(field).toLowerCase().trim();
            objectValue = objectValue.replace('&#x27;', "'");
            let flag = config.complex
                ? objectValue.split(/\s+\|\s+/).some(item => _value.indexOf(item) !== -1)
                : _value.indexOf(objectValue) !== -1;

            if (flag) {
                filtered.push(feature);
            }
        }
    });

    return filtered;
};

export const listTextFilter = (features, field, value, config) => (
    listObjectsFilter(features, field, value, config)
);

export const rangeFilter = (features, field, value) => {
    const filtered = [];
    features.forEach((feature) => {
        let objectValue = feature.get('obj').get(field);
        if (typeof objectValue === 'number') {
            if (objectValue >= Number(value[0])) {
                if ((value[1] && objectValue <= value[1]) || (value[1] === null)) {
                    filtered.push(feature);
                }
            }
        }
    });
    return filtered;
};

export const powersFilter = (features, field, value) => {
    const filtered = [];
    if (value[2] === false) {
        return features;
    }
    const steps = (field === 'power') ? [ 1, 3, 6 ] : [ 2, 5, 10 ];
    features.forEach((feature) => {
        let fValue = feature.get('obj').get(field);
        if (fValue === null) {
            return;
        }
        const _fValue = fValue.map((v) => (v === null ? undefined : v));
        const [ power, distance, possible ] = value;
        if (distance === steps[0] && _fValue[0] >= power) {
            filtered.push(feature);
        }
        if (distance === steps[1] && (_fValue[0] >= power || _fValue[1] >= power)) {
            filtered.push(feature);
        }
        if (distance === steps[2] && (_fValue[0] >= power || _fValue[1] >= power || _fValue[2] >= power)) {
            filtered.push(feature);
        }
    });
    return filtered;
};

export const waterFilter = (features, field, value) => {
    const filtered = [];
    features.forEach((f) => {
        if (!value) {
            filtered.push(f);
        } else {
            const fValue = f.get('obj').get(field);
            if (fValue) filtered.push(f);
        }
    });
    return filtered;
};
